import { buildMedhugRequestHeaders } from './requestHeaders';
import posthog from 'posthog-js';
import { buildBackendUrl } from '../api/backendUrl';

const CLICK_ENDPOINT = buildBackendUrl('/click');

/**
 * Fire-and-forget logging helper so we can record when users open learning resources.
 */
export function recordClickEvent({
  subject,
  body = '',
  level = 'info',
  isError = false,
} = {}) {
  if (!subject) {
    return;
  }

  const payload = {
    subject,
    body,
    level,
    is_error: isError,
  };
  const json = JSON.stringify(payload);
  let shouldFallbackToFetch = true;

  try {
    if (navigator && typeof navigator.sendBeacon === 'function') {
      const blob = new Blob([json], { type: 'text/plain;charset=UTF-8' });
      if (navigator.sendBeacon(CLICK_ENDPOINT, blob)) {
        shouldFallbackToFetch = false;
      }
    }
  } catch (err) {
    // fall back to fetch below
    console.debug('[click] sendBeacon failed, falling back to fetch', err);
  }

  if (shouldFallbackToFetch) {
    try {
      fetch(CLICK_ENDPOINT, {
        method: 'POST',
        headers: buildMedhugRequestHeaders({
          'Content-Type': 'text/plain;charset=UTF-8',
        }),
        body: json,
        keepalive: true,
      }).catch((err) => {
        console.debug('[click] fetch logging failed', err);
      });
    } catch (err) {
      console.debug('[click] logging threw before fetch', err);
    }
  }

  try {
    if (process.env.REACT_APP_POSTHOG_KEY) {
      posthog.capture('click_event', { subject, body, level, is_error: isError });
    }
  } catch (err) {
    console.debug('[click] posthog capture failed', err);
  }
}
